import styled from "styled-components";

import { media } from "../../styles/media";

export const ChatStyles = styled.div`
  position: fixed;
  top: 16px;
  bottom: 16px;
  right: 568px;
  height: calc(100vh - 32px);
  z-index: 1001;
  width: 0;
  overflow: hidden;
  pointer-events: none;
  transition: width 0.35s cubic-bezier(0.32, 0.72, 0.32, 1);

  &.isOpen {
    width: 460px;
  }

  .chatInner {
    pointer-events: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 460px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    box-shadow: -10px 10px 30px rgba(14, 12, 31, 0.1),
      0 2px 8px rgba(14, 12, 31, 0.06);
    border-radius: 16px 0 0 16px;
    border-right: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    overflow: hidden;
    opacity: 0;
    transform: translateX(40px);
    transition: opacity 0.32s cubic-bezier(0.32, 0.72, 0.32, 1),
      transform 0.32s cubic-bezier(0.32, 0.72, 0.32, 1);
  }

  &.isOpen .chatInner {
    opacity: 1;
    transform: translateX(0);
  }

  .chatHead {
    flex-shrink: 0;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    gap: 10px;
  }

  .chatHeadTitle {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    line-height: 20px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .iconBtn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease,
      border-color 0.15s ease;
    padding: 0;
    text-decoration: none;
    flex-shrink: 0;
  }
  .iconBtn:hover {
    background: ${({ theme }) => theme.colors.semantic.container.gray};
  }
  .iconBtn svg {
    width: 16px;
    height: 16px;
  }

  .chatBox {
    flex: 1;
    min-height: 0;
    position: relative;
    overflow: hidden;
    background: #fcfcfd;
  }

  .inputContainer {
    flex-shrink: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    transition: background 0.2s ease, border-color 0.2s ease;
  }

  &.isNotifMode .inputContainer {
    background: ${({ theme }) => theme.colors.warn[50]};
    border-top-color: ${({ theme }) => theme.colors.warn[100]};
  }

  /* On mobile the ticket SideModal fills the screen, so the chat can't dock
     beside it — make it a full-screen overlay above the modal instead. */
  ${media.maxTablet`
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100vh;

    &.isOpen {
      width: 100vw;
    }

    .chatInner {
      width: 100vw;
      max-width: 100vw;
      border-radius: 0;
    }
  `}
`;
